import axios from '@dap/shared-utils/http.js';

export default {
    // 游戏测试阶段列表
    getGameTestingStageList (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/test_phase', { params });
    },

    // 实时数据
    getGameLc (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/rt5', { params });
    },

    // 分日数据表格
    getDailyList (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/daily', { params });
    },

    // 分日数据表格-下拉分国家数据
    getDailyCountryList (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/daily/country', {
            params,
        });
    },

    // 留存分析折线图
    getRetainTrend (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/retain/trend', {
            params,
        });
    },

    // 留存分析表格
    getRetainList (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/retain', { params });
    },

    // 留存分析分国家
    getRetainCountry (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/retain/country', {
            params,
        });
    },

    // ROI表格
    getRoiList (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/roi', { params });
    },

    // ROI分国家
    getRoiCountry (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/roi/country', {
            params,
        });
    },

    // LTV分析表格
    getLtv (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/ltv', { params });
    },

    // LTV分析分国家
    getLtvCountry (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/ltv/country', {
            params,
        });
    },

    // 国家分析图
    getCountryTop5 (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/country/top5', {
            params,
        });
    },

    // 国家分析表格
    getInsightsCountry (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/country', { params });
    },

    // 国家分析分日
    getInsightsCountryDaily (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/country/daily', {
            params,
        });
    },

    // 渠道分析折线图
    getInsightsDailyTrend (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/daily_trend', {
            params,
        });
    },

    // 渠道分析表格
    getInsightsMediaSrc (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/media_src', { params });
    },

    // 渠道分析分日
    getInsightsMediaSrcDaily (params = {}) {
        return axios.get('/dapper/api/insights/game_lc/media_src/daily', {
            params,
        });
    },

    // 国家维度
    getDimCountrys (params = {}) {
        return axios.get('/coach/api/dim_countrys', { params });
    },
};
